import { render, staticRenderFns } from "./Faturar.vue?vue&type=template&id=3f5b2cf1"
import script from "./Faturar.vue?vue&type=script&lang=js"
export * from "./Faturar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports